import { useState } from "react";
import DeviceDataTable from "./components/DeviceDataTable";
import DeviceDataTiles from "./components/DeviceDataTiles";
import BackButton from "../../Home/components/KnowledgeCentre/BackButton";

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

export default function Devices() {
  const [tileData, setTilesData] = useState<ColumnObjType>()
  const handleTiles = (data: ColumnObjType) => {
    setTilesData(data)
  }

  return (
    <div className="flex flex-col gap-4">
      <BackButton />
      <div className="flex-1">
        <DeviceDataTiles data={tileData} />
      </div>
      <div className="flex-1 tripTable">
        <DeviceDataTable  handleTile={handleTiles} />
      </div>
    </div>
  );
}
